import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Tooltip, Paper } from '@material-ui/core';

import style from '../awbReturn.module.css';
import commonStyles from '../../../common/common.module.css';
import CartItem from '../../../../models/CartItem';
import MaterialTable from 'material-table';
import CartService from '../../../../models/CartService';
import { getAdditionalServiceName } from '../../../../utils/additionalServices';
import { formatCurrency } from '../../../../utils/currencyFormatter';
import addIcon from '../../../../assets/add.svg';

const styles = (theme: Theme) =>

  createStyles({
    formControlLabel: {
      marginRight: '2%',
      '& p': {
        fontSize: '14px'
      }
    },
    label: {
      color: 'rgb(9, 43, 74)'
    },
    addBox: {
      width: '18px',
    },
  });

interface ReturnChargesComponentProps {
  classes: any;
  handleOpenModal: (type: string) => void;
  cartItem: CartItem | undefined;
};

const returnChargesComponent = (props: ReturnChargesComponentProps) => {

  const { classes } = props;
  return (
    <Fragment>
    <div className={ `${ commonStyles.wrapper } ${ style.wrapper } ${ commonStyles.h100 }` }>
     
      <div className={ style.headerWrapper }>
        <h3 className={ commonStyles.header }> Return Charges</h3>
        <div>
          <Tooltip title="Add additional services">
            <img src={addIcon} alt="Add additional services" onClick={ () => props.handleOpenModal('addCharges') } className={ classes.addBox }/>
          </Tooltip>
        </div>
      </div>

      <div>
        <MaterialTable
          components={{Container: props => <Paper {...props} elevation={0} className={ `${ commonStyles.paperTable }` } /> }}

          data={ props.cartItem ? props.cartItem.services : [] }

          localization = {{
            header: { actions: '' }
          }}
    
        columns={[
          { title: 'Fee', field: '', cellStyle: { width: '200px' , paddingRight: 0},
            render: (rowData: CartService) => { 
              if (rowData.type === 'other' || rowData.type === 'gha_adjust') {
                return (<span>{ getAdditionalServiceName(rowData.type) }: {rowData.params.reason}</span>); 
              }
              return (<span>{ getAdditionalServiceName(rowData.type) }</span>);
            }
          },
          { title: 'Due', field: 'remain', type:'currency', headerStyle: { paddingTop: '10px' }, cellStyle: { width: '110px', paddingRight: 0 } },
        
        ]}

        options={{
          selection: false,
          paging: false,
          actionsColumnIndex: -1,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          rowStyle: {
            height: '30px'
          },
          showTitle: false,
          toolbar: false,
          sorting: false
        }}
      />	
      </div>

      <div className={ style.totalWrapper }>
        <div></div>
       
        <div>Total:   { formatCurrency(props.cartItem ? props.cartItem.remainDue : 0, 2, '$') }</div>
      </div>
    </div>
  </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    manualEntryEdit: state.manualEntryEdit,
    manualEntryAdd: state.manualEntryAdd
  };
}

export default withStyles(styles)(connect(mapStateToProps, {})(returnChargesComponent));
